import _ from 'lodash';
import { Accessors, ComputedOptions } from 'vue/types/options';
import { store } from '@/main/store';

import { pnue } from '../store/edit';
import { Pneu } from '../store/types';

export function genPneuComputeds(): Accessors<Pneu> {
	return _.mapValues(
		pnue,
		(keyValue, key: string, object: any) => getterAndSetterFromPneuKey(key, object),
	) as Accessors<Pneu>;
}

type MutationThis = { storeUri: string, index: number };

// eslint-disable-next-line no-unused-vars
export function getterAndSetterFromPneuKey<T>(key: string, object: T): ComputedOptions<T> {
	return {
		get(this: MutationThis): any {
			return store.getters[`${this.storeUri}/getPolozkaField`](`[${this.index}].${key}`);
		},
		set(this: MutationThis, value: T): void {
			store.commit(`${this.storeUri}/updatePolozkaField`, {
				path: `[${this.index}].${key}`,
				value,
			});
		},
	};
}
